import React from 'react';
import { FormattedMessage } from 'react-intl';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import Constants from '../../../definitions/constants';

import GlassPopup from '../common/interface/glassPopup';
import TextBox from '../common/inputs/textBox';
import ErrorFeedback from '../common/feedback/errorFeedback';

const ChangePasswordFormPopup = props => {
  const {
    handleShowPopup,
    handleOnChangeForm,
    handleButton,
    loadingButton,
    fullLoading,
    statusButton,
    formData,
    errors,
    popupState
  } = props;
  return (
    <GlassPopup
      className="form_popup"
      title={(<FormattedMessage id={"dashboard.changePassword.title"}/>)}
      buttonText={(<FormattedMessage id={"dashboard.changePassword.title"}/>)}
      {...props}
      handleButton={!JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"user.customer_is_single_sign_on") ? handleButton : null}
    >
      <ErrorFeedback
        status={statusButton}
        fieldErrors={errors}
        localesFieldsPath="userAdmin.fields"
      />
      {(!JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"user.customer_is_single_sign_on")) && (
        <div>
          <label className="form_info">
            <FormattedMessage id={"userAdmin.form.passwordHelpEdit"}/>
          </label>
          <form>
            <TextBox 
              styleType={Constants.interface.inputs.styleType.OUTLINED}
              type={Constants.interface.inputs.type.PASSWORD}
              id="password"
              data-path="user.password"
              value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"user.password")}
              onChange={handleOnChangeForm}
              labelLocale={<FormattedMessage id="userAdmin.fields.password"/>}
            />
            <TextBox 
              styleType={Constants.interface.inputs.styleType.OUTLINED}
              type={Constants.interface.inputs.type.PASSWORD}
              id="repeat_password"
              data-path="repeat_password"
              value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"repeat_password")}
              onChange={handleOnChangeForm}
              labelLocale={<FormattedMessage id="userAdmin.fields.repeat_password"/>}
            />
          </form>
        </div>
      )}
      {(JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"user.customer_is_single_sign_on")) && (
        <div>
          <label className="form_info">
            <FormattedMessage id={"userAdmin.passwordHelpSSO"}/>
          </label>
        </div>
      )}
    </GlassPopup>
  );
};

export default ChangePasswordFormPopup;



// WEBPACK FOOTER //
// ./source/client/components/dashboard/changePasswordFormPopup.jsx